import React, { useEffect, useState } from 'react'
import { Grid, makeStyles, Zoom } from '@material-ui/core';
import { GenericDocumentacion } from '../../../atomic/organisms/GenericDocumentacion';
import MuiAlert from '@material-ui/lab/Alert';
import { useDispatch } from 'react-redux';
import { getTiposDocumentacionAfiliadoWeb, removeDocumentacionAfiliacionWeb, uploadDocumentacionAfiliacionWeb } from '../../../../actions/preAfiliado/afiliadoWeb';

const useStyles = makeStyles(() => ({
  rootListadoc: {
    margin: 30,
  },
}));

export const DocumentacionPreAfiliadoWeb = ({ form }) => {

  const classes = useStyles()
  const dispatch = useDispatch()
  
  const [tiposDocumentacion, setTiposDocumentacion] = useState([])
  useEffect(() => {
    dispatch(getTiposDocumentacionAfiliadoWeb(setTiposDocumentacion))
  }, [])


  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  return (
    <Zoom style={{ transitionDelay: "100ms" }} in={true}>
      <Grid container spacing={1}>
        <Grid className={classes.rootListadoc}>
          {form.formValues.documentacion.length === tiposDocumentacion.length ?
            <Alert severity="success">Estado: DOCUMENTACIÓN COMPLETA</Alert>
            : <Alert severity="warning">Estado: DOCUMENTACIÓN FALTANTE</Alert>
          }
          <Grid item className={classes.rootListadoc}>
            <GenericDocumentacion
              tiposDocumentacion={tiposDocumentacion}
              documentacion={form.formValues.documentacion.map((item) => ({...item, idDocumentacion: item.id }))}
              disabledAdd={(doc) => form.formValues.documentacion.some(x => x.idTipoDoc === doc.idTipoDoc)}
              deleteDocumentacion={(id) => {
                dispatch(removeDocumentacionAfiliacionWeb(id, form.setearValor, form.formValues))
              }}
              handleFile={(files, idTipDoc) => {
                dispatch(uploadDocumentacionAfiliacionWeb(files, idTipDoc, form.formValues.idAfiliado, form.setearValor, form.formValues))
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Zoom>
  )
}
